import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { StationService } from 'src/app/services/station.service';
import { ProjectAttributesService } from 'src/app/services/project-attributes.service';
import { AccessLevels } from 'src/app/models/access_levels';
import { EmployeeService } from 'src/app/services/employee.service';
import * as moment from 'moment';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-add-outsourced-agency',
  templateUrl: './add-outsourced-agency.component.html',
  styleUrls: ['./add-outsourced-agency.component.scss']
})
export class AddOutsourcedAgencyComponent implements OnInit {

  roles = [{ access_level: 2, role: 'Station Manager', name: 'Station Manager' },
  { access_level: 3, role: 'Concierge', name: 'Concierge' },
  { access_level: 3, role: 'Sr. Concierge', name: 'Sr. Concierge' }]
  jobTypes = ['Full Time', 'Part Time']
  status = ['Active', 'Inactive']
  traineeTypes = ['Yes', 'No']
  employee_form: FormGroup;

  selectedStatus: any;
  selectedJobName: any;
  selectedJobType: any;
  selectedLanguageids = [];
  selectedRole: any;
  selectedStations = [];
  selectedState: any;
  selectedCountry: any;

  allStations: any
  allLanguages: any
  allJobNames: any
  allCountries: any
  allStates: any

  isEditMode = false;
  formTitle = '';
  submitted = false
  maxDate = new Date();
  minDate = new Date(1900, 1, 1);

  hide = false;

  selectedTraineeType: any;
  employeeData;

  public constructor(
    private formBuilder: FormBuilder,
    private notifier: NotifierService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private spinner: NgxSpinnerService,
    private employeeService: EmployeeService,
    private stationService: StationService,
    private authenticationService: AuthenticationService,
    private projectAttrService: ProjectAttributesService) {
  }

  ngOnInit() {
    this.getStations();
    this.getProjectAttributes();
    this.getAllLanguages();
    if (this.route.snapshot.paramMap.get('id') != null) {
      this.formTitle = "Update Outsourced Agency";
      this.isEditMode = true;
      this.getEmployeeById(this.route.snapshot.paramMap.get('id'));
    } else {
      this.formTitle = "Add Outsourced Agency"
    }
    this.initAddEmployeeForm();
  }

  initAddEmployeeForm() {
    this.employee_form = new FormGroup({
      empid: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(15)])),
      fname: new FormControl('', Validators.compose([Validators.required, Validators.pattern('[0-9A-Za-z ]*')])),     
      email: new FormControl('', Validators.compose([Validators.required, Validators.email])),     
      status: new FormControl(''),
      stations: new FormControl('', Validators.compose([Validators.required])),
      mobileNumber: new FormControl('', Validators.compose([Validators.required, Validators.pattern('^[0-9\-\+]*$')])),     
      country: new FormControl(''),
    });
  }


  initUpdateEmployeeForm() {
    this.employee_form = this.formBuilder.group({
      empid: new FormControl(this.employeeData.emp_id, Validators.compose([Validators.required, Validators.maxLength(15)])),
      fname: new FormControl(this.employeeData.firstname, Validators.compose([Validators.required, Validators.minLength(3), Validators.pattern('[0-9A-Za-z ]*')])), 
      email: new FormControl(this.employeeData.email, Validators.compose([Validators.required, Validators.email])),
      stations: new FormControl(this.selectedStations, Validators.compose([Validators.required])),
      status: new FormControl(this.selectedStatus, Validators.required),
      mobileNumber: new FormControl(this.employeeData.mobileno, Validators.compose([Validators.required , Validators.pattern('^[0-9\-\+]*$')])),
      country: new FormControl(''),
    });
    // this.setCapValidators(this.selectedRole);
  }

  setCapValidators(role) {
    if (role.access_level == AccessLevels.agent) {
      this.employee_form.get('dailycap').setValidators([Validators.required]);
      this.employee_form.get('weeklycap').setValidators([Validators.required]);
      this.employee_form.get('hourlyrate').setValidators([Validators.required]);

      this.employee_form.get('dailycap').updateValueAndValidity();
      this.employee_form.get('weeklycap').updateValueAndValidity();
      this.employee_form.get('hourlyrate').updateValueAndValidity();
    } else {
      this.employee_form.get('dailycap').setValidators(null);
      this.employee_form.get('weeklycap').setValidators(null);
      this.employee_form.get('hourlyrate').setValidators(null);

      this.employee_form.get('dailycap').updateValueAndValidity();
      this.employee_form.get('weeklycap').updateValueAndValidity();
      this.employee_form.get('hourlyrate').updateValueAndValidity();
    }
  }

  get employee_form_controls() { return this.employee_form.controls; }

  onAddOutsourcedEmployee(values) {
  
    this.submitted = true
    this.validateEmployee()

    if (this.selectedState == null || this.selectedState == 'undefined') {
      this.selectedState = ''
    }
    if (this.selectedCountry == null || this.selectedCountry == 'undefined') {
      this.selectedCountry = ''
    }
    this.employee_form.markAllAsTouched();
    if (this.employee_form.invalid) {
      // console.log('issue Calling');
      return;
    }

    var data = {
      "firstname": values.fname,
      "lastname": '',
      "preferred_name": values.fname,
      "email": values.email,
      "password": 'WelcomeATS',
      "dob": new Date(),
      "hire_Date": new Date(),
      "job_code": "Concierge",
      "job_name": "Concierge",
      "job_type": "Full Time",
      "role": 'Concierge',
      "mobileno": values.mobileNumber,
      "emp_id": values.empid,
       "access_level": 3,
      "station": { "ids": this.selectedStations, "update": true },
      "language": { "ids": [2], "update": true },
      "languages": "English,French",
      "address1": "address1",
      "address2": "address2",
      "city": "city",
      "state": "state",
      "zipcode": "123",
      "country": 'USA',
      "IS_TRAINEE": 'No',
      "daily_cap": 3, 
      "weekly_cap": 10, 
      "hourly_rate": 5,
    }

    this.spinner.show()
    this.employeeService.saveEmployee(data).subscribe(res => {
      if (res['status']) {
        this.spinner.hide()
        this.submitted = false
        this.notifier.notify('success', 'Outsourced Agency details added successfully.');
        setTimeout(() => {
         this.location.back()
         this.router.navigateByUrl("home/outsourceAgency");
        }, 2000);
      } else {
        this.submitted = false
        this.spinner.hide()
        this.notifier.notify('danger', res['message'])
      }
    }, err => {
      this.notifier.notify('danger', err.message)
      console.log(err);
    })
  }


  onUpdateOutsourcedEmployee(values) {
    this.submitted = true
    this.validateEmployee()
    this.employee_form.markAllAsTouched();
    if (this.employee_form.invalid) {
      // console.log('issue Calling');
      return;
    }
    if (this.selectedState == null || this.selectedState == 'undefined') {
      this.selectedState = ''
    }
    if (this.selectedCountry == null || this.selectedCountry == 'undefined') {
      this.selectedCountry = ''
    }

    var data = {
      "id": this.employeeData.id,
      "firstname": values.fname,
      "lastname": '',
      "preferred_name": this.employeeData.preferred_name,
      "email": values.email,
      "password": 'WelcomeATS',
      "hire_Date": new Date(),
      "job_code": "Concierge",
      "job_name": "Concierge",
      "job_type": "Full Time",
      "role": "Concierge",
      "mobileno": values.mobileNumber,
      "emp_id": values.empid,
      "access_level": 3,
      "language": { "ids": [2], "update": true },
      "languages": "English,French",
      "station": { "ids": this.selectedStations, "update": true },
      "address1": 'address1',
      "address2": 'address2',
      "city": 'city',
      "state": 'state',
      "zipcode": '123',
      "country": 'USA',
      "IS_TRAINEE": 'No',
      "daily_cap": 3, 
      "weekly_cap": 10, 
      "hourly_rate": 5,
    }

    if (values.status != this.status[0]) {
      data["status"] = false;
    } else {
      data["status"] = true;
    }

    this.spinner.show()
    this.employeeService.updateEmployee(data).subscribe(res => {
      if (res['status']) {
        this.spinner.hide()
        this.submitted = false
          this.notifier.notify('success', 'Outsourced Agency details updated successfully.');
          setTimeout(() => {
           this.location.back()
           this.router.navigateByUrl("home/outsourceAgency");
          }, 2000);
      } else {
        this.submitted = false
        this.spinner.hide()
        this.notifier.notify('danger', res['message'])
      }
    }, err => {
      this.notifier.notify('danger', err.message)
      console.log(err);
    })
  }

  validateAddress(values) {

  }

  onStationChange(event) {
    this.selectedStations = (event)
  }

  validation_messages = {
    'status': [
      { type: 'required', message: 'Status is required.' }
    ],
    'stations': [
      { type: 'required', message: 'Station is required.' }
    ],
    'empid': [
      { type: 'required', message: 'Agency ID is required.' },
      { type: 'maxlength', message: 'Agency ID should not be more than 15 characters long.' }
    ],
    'fname': [
      { type: 'required', message: 'Company Name is required.' },
     // { type: 'minlength', message: 'Company name must be 3 characters long.' },
      { type: 'pattern', message: 'Please enter alpha-numeric only.' },
    //  { type: 'maxlength', message: 'Company name should not be more then 20 characters long.' }
    ],
    'email': [
      { type: 'required', message: 'Company Email is required.' },
      { type: 'email', message: 'Company Email format must be similar to joe@abc.com' },
    ],
    'mobileNumber': [
      { type: 'required', message: 'Phone No is required.' },
    //  { type: 'minlength', message: 'Mobile number must be minimum 10 digits long.' },
    //  { type: 'maxlength', message: 'Mobile number must not be more then 20 digits long.' },
      { type: 'pattern', message: 'Phone No must not contain any alphabets or special characters  other than hyphen(-) and plus(+)' },
    ],

  }

  get f(): any {
    return this.employee_form.controls;
  }

  getStations() {
    if (this.authenticationService.isStationAdmin()) {
      // get login user stations
      this.employeeService.getEmployeeById(this.authenticationService.getCurrentUserId()).subscribe(res => {
        this.allStations = res['result']['stations']
      })
    } else {
      // get all stations
      this.stationService.getOutsourceStations().subscribe(stations => {
        this.allStations = stations['result'];
      })
    }
  }

  // This attributes includes job_code, job_name, Languages etc
  getProjectAttributes() {
    this.projectAttrService.getProjectAttributes().subscribe(projectAttrributes => {
      this.allCountries = projectAttrributes['result']['country']
      this.allJobNames = projectAttrributes['result']['job_name']
    })
  }

  getAllStatesByCountry() {
    this.projectAttrService.getAllStatesByCountry(this.selectedCountry).subscribe(res => {
      this.spinner.hide()
      this.allStates = res['result']
    })
  }

  getAllLanguages() {
    this.projectAttrService.getAllLanguages().subscribe(res => {
      this.allLanguages = res['result']
    })
  }

  getEmployeeById(emp_id) {
    this.spinner.show();
    this.employeeService.getEmployeeById(emp_id).subscribe(employee => {
      this.employeeData = employee['result']
      this.selectedJobType = this.employeeData.job_type;
      // this.selectedTraineeType = this.employeeData.IS_TRAINEE;
      this.selectedStatus = this.employeeData.status ? this.status[0] : this.status[1];
      this.selectedCountry = this.employeeData.country
      this.getAllStatesByCountry();
      this.selectedState = this.employeeData.state
      // this.selectedJobCode = this.employeeData.job_code;
      // this.selectedJobName = this.employeeData.job_name;
      this.employeeData.language.forEach(language => {
        this.selectedLanguageids.push(language.languageId);
      });

      this.employeeData.stations.forEach(station => {
        this.selectedStations.push(station.id);
      });

      if (this.employeeData.access_level == AccessLevels.stationManager) {
        this.selectedRole = this.roles[0]
      } else if (this.employeeData.role == "Sr. Concierge") {
        this.selectedRole = this.roles[2]
      } else {
        this.selectedRole = this.roles[1]
      }

      this.spinner.hide();
      this.initUpdateEmployeeForm();
    });
  }

  clearField(formFieldName) {
    this.employee_form.get(formFieldName).setValue('')
  }

  onDateChange(value) {
    if (value > new Date()) {
      this.notifier.notify('warning', 'Future date not allowed!')
    }
  }

  onBack() {
    this.location.back();
  }

  onRest() {
    this.submitted = false
    this.employee_form.reset();
    // this.employee_form_controls.password.setValue("WelcomeATS")

  }

  myFunction() {
    this.hide = !this.hide;
  }

  validateEmployee() {
    if (this.employee_form_controls.empid.errors) {
      this.notifier.notify('warning', 'Please enter Agency ID')
      return false;
    }
    if (this.employee_form_controls.fname.errors) {
      this.notifier.notify('warning', 'Please enter Company Name')
      return false;
    }
    if (this.employee_form_controls.email.errors) {
      this.notifier.notify('warning', 'Please enter Company Email')
      return false;
    }
    if (this.employee_form_controls.mobileNumber.errors) {
      this.notifier.notify('warning', 'Please enter Phone No')
      return false;
    }
    if (this.isEditMode && this.employee_form_controls.status.errors) {
      this.notifier.notify('warning', 'Please select Status')
      return false;
    }
    if (this.employee_form_controls.stations.errors) {
      this.notifier.notify('warning', 'Please select Stations')
      return false;
    }
  }

}
